import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api, { setToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        setToken(data.session_token);
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        const dest = data.user.role === "admin" ? "/admin" : data.user.role === "organizer" ? "/organizer" : "/dashboard";
        nav(dest, { replace: true });
      } catch {
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#0a1420]">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-slate-700 border-t-[#22d3ee] rounded-full animate-spin mx-auto" />
        <p className="text-slate-300 mt-4 font-body">Signing you in…</p>
      </div>
    </div>
  );
}
